/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BadgeIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABYklEQVR4nN2VsU7DQAyGOzOAeAV4AToVoSK1TJWSs12kxG5Y6LPA1gUeBKZuSBEM8AQMLN1g6BvAQEGuWok254PoWOCkSBl8/uzf/901Gv9yIRZ7juTOobwByUedz5E8AUjLTJ4kxbZDntZNDKuQexPgkE/XNyDygRWf0qBdhfBjCHC5viGlQduWkw8rAJQrG0ByEyMPqETIZwEAv8QCELnwJu/1TjaBZBYLAJCmv/p+vv8L8rynabrhBQDkw8DmGSJ3APJusEvkiak/kIwC3i6/GKEMdDC2B4w89lXuSMrkuNhZxun/AuLrZGR3gDzxOKJjFtSXo+qA86E3WAejA/Js6NYBqFH81YM0reE6kpKId5ex+m9JlGXZlheghyNoP/rRkJ9N/R3K+Tcen6lcC1m8NtVrxgYQX8cfMrkwAXrFxgLActAcgPwQeUVM9bGyASCt+XNXP/krIN/qM2sm/9PrEzNvYFWXf1CaAAAAAElFTkSuQmCC)
 */
export const BadgeIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M4.6 4.52A3 3 0 0 1 7.54 2H19.9a2 2 0 0 1 1.97 2.32l-2.46 15.16A3 3 0 0 1 16.45 22H4.1a2 2 0 0 1-1.97-2.32L4.59 4.52ZM9 5a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1-1-1Zm3.91 5.63a.97.97 0 0 0-1.82 0l-.34.93a2 2 0 0 1-1.19 1.19l-.93.34a.97.97 0 0 0 0 1.82l.93.34a2 2 0 0 1 1.19 1.19l.34.93a.97.97 0 0 0 1.82 0l.34-.93a2 2 0 0 1 1.19-1.19l.93-.34a.97.97 0 0 0 0-1.82l-.93-.34a2 2 0 0 1-1.19-1.19l-.34-.93Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
